// extracted by mini-css-extract-plugin
module.exports = {"share":"share-module--share--wl-OH","text":"share-module--text--1Pxws","button":"share-module--button--21QQ1"};